import React, {useState, useEffect} from 'react';
import {useNavigate, Link} from 'react-router-dom';
import {useAuth} from './AuthContext';
import {toast} from '../Toast';

const loadInterFont = () => {
    if (!document.getElementById('inter-font')) {
        const link = document.createElement('link');
        link.id = 'inter-font';
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
        document.head.appendChild(link);
    }
};

export default function LoginPage() {
    useEffect(() => { loadInterFont(); }, []);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const {login} = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        const result = await login({email, password});
        setIsLoading(false);
        if (result.ok) {
            toast.success('Welcome back! Logged in successfully.');
            navigate('/dashboard');
        } else {
            setError(result.error || 'Invalid email or password');
        }
    };

    const inputStyle = {
        width: '100%',
        padding: '14px',
        fontSize: '15px',
        fontFamily: "'Inter', sans-serif",
        background: '#ffffff',
        border: '1px solid #e5e5e5',
        borderRadius: '0.8rem',
        outline: 'none',
        boxSizing: 'border-box',
    };

    return (
        <>
            <style>{`
                .auth-page { display: grid; grid-template-rows: auto 1fr; min-height: 100vh; place-items: center; padding: 24px; gap: 24px; font-family: 'Inter', sans-serif; background-color: #ffffff; }
                .auth-card { max-width: 420px; width: 100%; padding: 28px 24px; background-color: #ffffff; }
                .auth-form { display: grid; gap: 16px; grid-template-columns: 1fr; }
                @media (min-width: 640px) { .auth-page { padding: 48px; } .auth-card { padding: 32px 40px; } }
            `}</style>
            <div className="auth-page">
                <div className="auth-card">
                    <img src="/images/Layer-1.png" alt="Optimus" style={{width: 'min(180px, 35vw)', height: 'auto', display: 'block', margin: '0 auto 24px'}} />
                    <h2 style={{fontSize: '38px', fontWeight: 700, textAlign: 'center', marginBottom: '16px', color: '#202020'}}>Sign In</h2>
                    <p style={{fontSize: '15px', color: '#4a4a4a', marginBottom: '24px', textAlign: 'center', lineHeight: 1.5}}>
                        Enter your email and password below to access your{' '}
                        <Link to="/" style={{color: '#0ea5e9', textDecoration: 'underline', fontWeight: 400}}>optimus.ink</Link> account.
                    </p>

                    {error && (
                        <div style={{display: 'flex', alignItems: 'center', gap: '8px', color: '#dc2626', fontSize: '14px', marginBottom: '16px'}}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{flexShrink: 0}}>
                                <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M5 5l6 6M11 5l-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="auth-form">
                        <div>
                            <input
                                type="email"
                                placeholder="Enter your email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoComplete="email"
                                autoCorrect="off"
                                autoCapitalize="none"
                                inputMode="email"
                                style={inputStyle}
                            />
                        </div>
                        <div>
                            <input
                                type="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={inputStyle}
                            />
                        </div>
                        <div style={{textAlign: 'right'}}>
                            <Link to="#" style={{fontSize: '14px', color: '#0ea5e9', textDecoration: 'none', fontWeight: '500'}}>Forgot Password?</Link>
                        </div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            style={{
                                width: '100%',
                                padding: '14px',
                                backgroundColor: '#000000',
                                color: '#ffffff',
                                fontSize: '16px',
                                fontWeight: '600',
                                fontFamily: "'Inter', sans-serif",
                                border: 'none',
                                borderRadius: '0.75rem',
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                opacity: isLoading ? 0.7 : 1,
                            }}
                            onMouseOver={(e) => { if (!isLoading) e.target.style.backgroundColor = '#1a1a1a'; }}
                            onMouseOut={(e) => { e.target.style.backgroundColor = '#000000'; }}
                        >
                            {isLoading ? 'Signing in...' : 'Sign in'}
                        </button>
                    </form>

                    <p style={{textAlign: 'center', marginTop: '24px', fontSize: '14px', color: '#4a4a4a'}}>
                        Don't have an account? <Link to="/register" style={{color: '#0ea5e9', textDecoration: 'none', fontWeight: '600'}}>Create account</Link>
                    </p>
                </div>
            </div>
        </>
    );
}
